/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 付帯商品検索情報
 */
export interface Szoa110aRequestFtiGoodsSearchInfo { 
    /**
     * プロダクトコード：英数字
     */
    prdCode: string;
    /**
     * カスタマイズ検索条件エリア
     */
    additionalCondition?: object | null;
}

